import * as api from "../../api/searchApi";
const SearchListModel = {
  state: {
    eventList: [] as Array<any>,
    competitionList: [] as Array<any>,
    isSearchListLoading: false,
    query: "",
    total: 0,
  },
  reducers: {
    resetSearchList(state: Record<string, any>): any {
      return {
        ...state,
        eventList: [],
        competitionList: [],
        isSearchListLoading: false,
        query: "",
        total: 0,
      };
    },

    setSearchListRequest(state: Record<string, any>, payload: string): any {
      return { ...state, isSearchListLoading: true, query: payload };
    },

    setSearchListSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        eventList: payload.eventList,
        competitionList: payload.competitionList,
        isSearchListLoading: false,
        total: payload.total,
      };
    },
  },
  effects: {
    async setSearchList(payload: Record<string, any>): Promise<any> {
      this.setSearchListRequest(payload);
      return api
        .getSearchList(payload)
        .then((searchData: any) => {
          if (searchData !== undefined) {
            this.setSearchListSuccess({
              eventList: searchData.events,
              competitionList: searchData.leagues,
              total: searchData.total,
            });
          }
        })
        .catch(error => {
          throw error;
        });
    },
  },
};
export default SearchListModel;
